import * as actionTypes from "../../actions/actionTypes";

const initState = {
 fileexport: "",
 filexportLoading: false,
 filexportError: null
};

const fileExportReducer = (state = initState, action) => {
 switch (action.type) {
  case actionTypes.FILE_EXPORT_SUCCESS:
   return {
    ...state,
    filexportLoading: false,
    fileexport: action.fileexport
   };

  default:
   return state;
 }
};
export default fileExportReducer;
